import styled from "styled-components";
import { useHistory } from "react-router-dom";

const FooterWrapper = styled.div`
  width: 100vw;
  position: absolute;
  bottom: 0;
  background-color: white;
  color: gray;
  font-size: 13px;
  text-justify: auto;
  padding: 2em 0 2em 0;
  height: 220px;

  @media (max-width: 480px) {
    height: 400px;
    width: 100%;
  }

  .text-content {
    margin: auto;
    text-align: justify;
    max-width: 800px;

    @media (max-width: 480px) {
      max-width: 100%;
      padding: 20px 30px;
    }
  }
`;

const GeneralFooter = ({ isFromAdvisorLogin = false }) => {
  const history = useHistory();
  return (
    <>
      <FooterWrapper>
        <div className="line"></div>
        <p className="text-content">
          {isFromAdvisorLogin && (
            <button
              style={{
                color: "#004576",
                fontSize: "14px",
                fontWeight: "800",
                cursor: "pointer",
                border: "none",
                background: "transparent",
              }}
              onClick={() => {
                history.push("/login");
              }}
            >
              Login as investor
            </button>
          )}
          <br /> Advisory services offered through Strategy Marketplace, LLC, a
          Delaware limited liability company dba Tactive. <br />
          <br />
          We are an independent financial services firm helping individuals
          create retirement strategies using various investment and insurance
          products to custom suit their needs and objectives. <br />
          <br />
          Investing involves risk, including the potential loss of principal. No
          investment strategy can guarantee a profit or protect against loss in
          periods of declining values. None of the information contained on this
          website shall constitute an offer to sell or solicit any offer to buy
          a security or any insurance product.
          <br />
          <br /> The information and opinions contained in any of the material
          requested from this website are provided by third parties. They have
          been obtained from sources believed to be reliable, but accuracy and
          completeness cannot be guaranteed. They are given for informational
          purposes only and are not a solicitation to buy or sell any of the
          products mentioned. The information is not intended to be used as the
          sole basis for financial decisions, nor should it be construed as
          advice designed to meet the particular needs of an individual’s
          situation.
        </p>
        <div className="line"></div>
      </FooterWrapper>
    </>
  );
};

export default GeneralFooter;
